"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pushDataLayer = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/gtm/pushDataLayer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * When search is not applicable
 * @param {string} screenName
 * @param {object} pickupBranch
 * @param {object} dropoffBranch
 */
function searchNotApplicable(screenName, pickupBranch, dropoffBranch) {
  var pickupBranchName = (0, _get2["default"])(pickupBranch, 'nameEn', '').toLowerCase();
  var dropoffBranchName = (0, _get2["default"])(dropoffBranch, 'nameEn', '').toLowerCase();
  var eventData = {
    event: 'search_not_applicable',
    screen_name: screenName,
    pickup_branch_name: pickupBranchName,
    dropoff_branch_name: dropoffBranchName
  };
  console.log('** gtm event search_not_applicable: ', eventData);
  (0, _pushDataLayer["default"])(eventData);
}
var _default = exports["default"] = searchNotApplicable;